// ----------------------------------------------------------------------------
// Component: Featured Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import 'snippets/background-media/background-media';
import 'snippets/reviews/reviews';

// Styles
import './_featured-product.scss';
